import { bunja } from 'bunja';
import { atom } from 'jotai';

import { positionOrderSort } from '@flipster/utils/sort';

import {
  ConditionalOrderTypeEnum,
  ordersAtom,
  type ConditionalOrderType,
  type Order,
  type PendingPosition,
} from './internal/fixed-topics/order';
import { r230522SocketBunja } from './socket';

export type * from './internal/fixed-topics/order';
export { ConditionalOrderTypeEnum };

/**
 * updated: 25/03/07
 * @see https://prextech.slack.com/archives/C0885FREU7Q/p1740029520015189?thread_ts=1739982915.087719&cid=C0885FREU7Q
 * orders에 qty, amount 값을 모두 채워서 내려보내주기 때문에 calc하지 않고 소켓값을 그대로 바라보게끔 변경함
 * 추후 사용성 없다고 판단되면 제거할 것
 * cc.hoyong
 */
const pendingPositionsAtom = atom((get) => {
  const orders = get(ordersAtom);
  if (!orders) return null;

  return Object.values(orders)
    .reduce((acc: PendingPosition[], o) => {
      // open position 제외
      const openPositionType: ConditionalOrderType[] = [
        ConditionalOrderTypeEnum.PositionTp,
        ConditionalOrderTypeEnum.PositionSl,
      ];
      if (openPositionType.includes(o.conditionalOrderType)) return acc;

      // amount = websocket:r230522/orders{symbol=String, slot=X}.amount
      // triggerPrice = websocket:r230522/orders{symbol=String, slot=X}.triggerPrice
      let orderType: 'qty' | 'amount';

      if (Number(o.qty || '0') === 0) {
        orderType = 'amount';
      }
      if (Number(o.qty || '0') > 0) {
        orderType = 'qty';
      }
      acc.push({
        ...o,
        orderType: orderType!,
        qty: o.qty || '0',
        amount: o.amount || '0',
      });
      return acc;
    }, [])
    .sort(positionOrderSort)
    .reduce((acc: Record<string, PendingPosition[]>, p) => {
      if (!acc[p.symbol]) acc[p.symbol] = []; // symbol이 없으면 초기화
      acc[p.symbol].push(p);
      return acc;
    }, {});
});
pendingPositionsAtom.debugLabel = 'pendingPositionsAtom';

const v2OrdersAtom = atom((get) => {
  const orders = get(ordersAtom);
  if (!orders) return {};

  return Object.values(orders).reduce((acc: Record<string, Order[]>, o) => {
    if (!acc[o.symbol]) acc[o.symbol] = [];
    acc[o.symbol].push(o);
    return acc;
  }, {});
});
v2OrdersAtom.debugLabel = 'v2OrdersAtom';

export const ordersBunja = bunja(() => {
  bunja.use(r230522SocketBunja);
  return {
    ordersAtom,
    pendingPositionsAtom,
    v2OrdersAtom,
  };
});
ordersBunja.debugLabel = 'ordersBunja';
